import { render, staticRenderFns } from "./VideoCategoryCombo.vue?vue&type=template&id=248f44a6&scoped=true"
import script from "./VideoCategoryCombo.vue?vue&type=script&lang=js"
export * from "./VideoCategoryCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f44a6",
  null
  
)

export default component.exports